import React from "react";
import { Form, Row, Col } from "react-bootstrap";

const ClientSection = ({
  formData,
  formErrors,
  onInputChange,
  isNotApplicable,
}) => {
  return (
    <div className="appointment-section">
      <div className="section-header">
        <div className="section-header-content">
          <h6 className="section-title">Client</h6>
          <Form.Check
            type="checkbox"
            id="client-not-applicable"
            checked={isNotApplicable}
            onChange={(e) =>
              onInputChange("clientNotApplicable", e.target.checked)
            }
            label="Not Applicable"
            className="not-applicable-checkbox"
          />
        </div>
      </div>
      <div
        className="section-fields"
        style={{ display: isNotApplicable ? "none" : "block" }}
      >
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.clientName}
                onChange={(e) => onInputChange("clientName", e.target.value)}
                isInvalid={!!formErrors.clientName}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                value={formData.clientPhone}
                onChange={(e) => onInputChange("clientPhone", e.target.value)}
                isInvalid={!!formErrors.clientPhone}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientPhone}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>
                Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                value={formData.clientEmail}
                onChange={(e) => onInputChange("clientEmail", e.target.value)}
                isInvalid={!!formErrors.clientEmail}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientEmail}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.clientNote}
                onChange={(e) => onInputChange("clientNote", e.target.value)}
                isInvalid={!!formErrors.clientNote}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientNote}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ClientSection;
